import { render, staticRenderFns } from "./DrugIcon.vue?vue&type=template&id=797fb4e3&scoped=true"
import script from "./DrugIcon.vue?vue&type=script&lang=js"
export * from "./DrugIcon.vue?vue&type=script&lang=js"
import style0 from "./DrugIcon.vue?vue&type=style&index=0&id=797fb4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fb4e3",
  null
  
)

export default component.exports